import icon_addText from '../i/add_text.svg'
import icon_addImg from '../i/add_img.svg'
import icon_addVideo from '../i/add_video.svg'
import icon_addCta from '../i/add_cta.svg'

import icon_cookies from '../i/cookies_icon.svg'
import icon_cookies_active from '../i/cookies_icon--active.svg'

import icon_quiz from '../i/quiz_icon.svg'
import icon_quiz_active from '../i/quiz_icon--active.svg'

import icon_leadForm from '../i/leadForm_icon.svg'
import icon_leadForm_active from '../i/leadForm_icon--active.svg'

import icon_personality_quiz from '../i/personality_quiz_icon.svg'
import icon_personality_quiz_active from '../i/personality_quiz_icon--active.svg'

import icon_memory from '../i/memory_icon.svg'
import icon_memory_active from '../i/memory_icon--active.svg'

import icon_interactiveImage from '../i/interactive_image_icon.svg'
import icon_interactiveImage_active from '../i/interactive_image_icon--active.svg'

import icon_hiddenObjects from '../i/hiddenObjects_icon.svg'
import icon_hiddenObjects_active from '../i/hiddenObjects_icon--active.svg'

import icon_horoscope from '../i/horoscop_icon.svg'
import icon_horoscope_active from '../i/horoscop_icon--active.svg'

import icon_flipCards from '../i/flipCards_icon.svg'
import icon_flipCards_active from '../i/flipCards_icon--active.svg'

import icon_thenNow from '../i/thenNow_icon.svg'
import icon_thenNow_active from '../i/thenNow_icon--active.svg'

import icon_timeline from '../i/timeline_icon.svg'
import icon_timeline_active from '../i/timeline_icon--active.svg'

import icon_findPair from '../i/findPair_icon.svg'
import icon_findPair_active from '../i/findPair_icon--active.svg'

import icon_slideshow from '../i/slideshow_icon.svg'
import icon_slideshow_active from '../i/slideshow_icon--active.svg'

import iconUnlocked from '../i/unlocked.svg'
import iconLocked from '../i/locked.svg'

import icon_puzzle from '../i/puzzleIcon.svg'
import icon_puzzle_active from '../i/puzzleIcon--active.svg'

import BLOCK from '../../../../../common/constants/BlockTypes/BlocksEnum'
import { DEFAULT_IMAGE_URL } from '../../../../../common/constants/constants'
import { genUniqueId } from '../../../../../common/utils/genUniqueId'
import { TIME_IS_UP_INIT_STATE } from '../Modals/TimeIsUpModal/utils/constants.js'
import { MODAL_NAMES } from '../Modals/ModalController.jsx'
import { CONTROLS_ENUM } from '../Panels/Control/constants.js'

import {
    MODE as leadFormMode,
    INIT_STRUCTURE_BY_MODE as initLeadFormStructureByMode,
} from '../Modals/LeadFormModal/constants'

import i18n from '../../../../../i18n'

const STATIC_BLOCKS = [
    {
        t: BLOCK.text,
        icon: icon_addText,
        label: i18n.t('Text'),
        labelForRightPanel: i18n.t('Text'),
    },
    {
        t: BLOCK.image,
        icon: icon_addImg,
        label: i18n.t('Image'),
        labelForRightPanel: i18n.t('Image'),
    },
    {
        t: BLOCK.youtubeVideo,
        icon: icon_addVideo,
        label: i18n.t('Youtube video'),
        labelForRightPanel: i18n.t('Youtube video'),
    },
    {
        t: BLOCK.button,
        icon: icon_addCta,
        label: i18n.t('Button'),
        labelForRightPanel: i18n.t('Button'),
    },
]

const INTERACTIVE_BLOCKS = [
    {
        t: BLOCK.quiz,
        icon: icon_quiz,
        iconActive: icon_quiz_active,
        label: i18n.t('Quiz'),
        labelForRightPanel: i18n.t('Quiz settings'),
        color: '#FF5656',
        hasTemplates: true,
        templatesTitle: i18n.t('Quiz templates'),
    },
    {
        t: BLOCK.personalityQuiz,
        icon: icon_personality_quiz,
        iconActive: icon_personality_quiz_active,
        label: i18n.t('Personality'),
        labelForRightPanel: i18n.t('Personality Quiz settings'),
        color: '#784DBA',
        hasTemplates: true,
        templatesTitle: i18n.t('Personality Quiz templates'),
    },
    {
        t: BLOCK.memoryCards,
        icon: icon_memory,
        iconActive: icon_memory_active,
        label: i18n.t('Memory'),
        labelForRightPanel: i18n.t('Memory settings'),
        color: '#41AD6A',
        hasTemplates: true,
        templatesTitle: i18n.t('Memory templates'),
    },
    {
        t: BLOCK.findPair,
        icon: icon_findPair,
        iconActive: icon_findPair_active,
        label: i18n.t('Find Pair'),
        labelForRightPanel: i18n.t('Find pair settings'),
        color: '#41AD6A',
        hasTemplates: true,
        templatesTitle: i18n.t('Find pair templates'),
    },
    {
        t: BLOCK.slideshow,
        icon: icon_slideshow,
        iconActive: icon_slideshow_active,
        label: i18n.t('Slideshow'),
        labelForRightPanel: i18n.t('Slideshow'),
        color: '#24BFD8',
        hasTemplates: true,
        templatesTitle: i18n.t('Slideshow templates'),
    },
    {
        t: BLOCK.leadForm,
        icon: icon_leadForm,
        iconActive: icon_leadForm_active,
        label: i18n.t('Lead form'),
        labelForRightPanel: i18n.t('Lead form settings'),
    },
    {
        t: BLOCK.flipCards,
        icon: icon_flipCards,
        iconActive: icon_flipCards_active,
        label: i18n.t('Flip Card'),
        labelForRightPanel: i18n.t('Flip Card'),
    },
    {
        t: BLOCK.thenNow,
        icon: icon_thenNow,
        iconActive: icon_thenNow_active,
        label: i18n.t('Then & Now'),
        labelForRightPanel: i18n.t('Then & Now'),
    },
    {
        t: BLOCK.timeline,
        icon: icon_timeline,
        iconActive: icon_timeline_active,
        label: i18n.t('Timeline'),
        labelForRightPanel: i18n.t('Timeline'),
    },
    {
        t: BLOCK.cookies,
        icon: icon_cookies,
        iconActive: icon_cookies_active,
        label: 'Cookies',
        labelForRightPanel: 'Cookies settings',
        color: '#FF9C40',
        hasTemplates: true,
        templatesTitle: i18n.t('Cookies templates'),
    },
    {
        t: BLOCK.horoscope,
        icon: icon_horoscope,
        iconActive: icon_horoscope_active,
        label: 'Horoscope',
        labelForRightPanel: 'Horoscope settings',
        color: '#D372CA',
        hasTemplates: true,
        templatesTitle: i18n.t('Horoscope templates'),
    },
    {
        t: BLOCK.interactiveImage,
        icon: icon_interactiveImage,
        iconActive: icon_interactiveImage_active,
        label: i18n.t('Interactive image'),
        labelForRightPanel: i18n.t('Interactive image'),
        color: '#FFBE5C',
        hasTemplates: true,
        templatesTitle: i18n.t('Interactive image templates'),
    },
    {
        t: BLOCK.hiddenObjects,
        icon: icon_hiddenObjects,
        iconActive: icon_hiddenObjects_active,
        label: i18n.t('Hidden objects'),
        labelForRightPanel: i18n.t('Hidden objects'),
        color: '#2AB8A9',
        hasTemplates: true,
        templatesTitle: i18n.t('Hidden objects templates'),
    },
    {
        t: BLOCK.puzzle,
        icon: icon_puzzle,
        iconActive: icon_puzzle_active,
        label: i18n.t('Puzzle'),
        hasTemplates: true,
        labelForRightPanel: i18n.t('Puzzle'),
    },
]

const BLOCK_DICTIONARY = [...STATIC_BLOCKS, ...INTERACTIVE_BLOCKS].reduce((dictionary, block) => {
    dictionary[block.t] = block
    return dictionary
}, {})

const PINS_SCHEMA_DICTIONARY = {
    h: {
        label: i18n.t('Title'),
        type: 'string',
        default: '',
        control: CONTROLS_ENUM.TextInput,
    },
    d: {
        label: i18n.t('Description'),
        type: 'string',
        default: '',
        control: CONTROLS_ENUM.TextArea,
    },
    i: {
        label: i18n.t('Image'),
        type: 'string',
        default: '',
        control: CONTROLS_ENUM.UploadButton,
    },
    blink: {
        label: i18n.t('Button link'),
        type: 'string',
        default: '',
        control: CONTROLS_ENUM.InputWithModal,
        payload: {
            modalName: MODAL_NAMES.selectInternalPageModal,
        },
    },
    btext: {
        label: i18n.t('Button text'),
        type: 'string',
        default: 'Ok',
        control: CONTROLS_ENUM.TextInput,
    },
}

const BLOCK_SCHEMA_DICTIONARY = {
    [BLOCK.text]: {
        // wrapper props
        wP_bg: {
            label: i18n.t('Background color'),
            type: 'string',
            default: '#fff',
            control: CONTROLS_ENUM.ColorPicker,
        },
        text: {
            type: 'string',
            default: `<p><span class="ql-font-Roboto" style="font-size: 14px; line-height: 1.5;">${i18n.t(
                'Tell your story…',
            )}</span></p>`,
            minLength: 0,
            maxLength: 16000,
        },
    },
    [BLOCK.image]: {
        url: {
            label: i18n.t('Image'),
            type: 'string',
            default: '',
            control: CONTROLS_ENUM.UploadButton,
        },
        blur: {
            label: i18n.t('Interactive blur'),
            type: 'boolean',
            default: false,
            control: CONTROLS_ENUM.Checkbox,
        },
    },
    [BLOCK.embedInteractyProject]: {
        embedCode: {
            label: i18n.t('Embed code'),
            type: 'string',
            default: '',
            control: CONTROLS_ENUM.TextArea,
        },
    },
    [BLOCK.flipCards]: {
        imageProportions: {
            label: i18n.t('Image proportions'),
            type: 'object',
            default: {
                value: '3|2',
                label: '3:2',
            },
            control: CONTROLS_ENUM.Select,
            payload: {
                items: [
                    {
                        value: '1|1',
                        label: '1:1',
                    },
                    {
                        value: '5|4',
                        label: '5:4',
                    },
                    {
                        value: '4|3',
                        label: '4:3',
                    },
                    {
                        value: '3|2',
                        label: '3:2',
                    },
                    {
                        value: '16|9',
                        label: '16:9',
                    },
                ],
            },
        },
        frontSrc: {
            label: i18n.t('Front image'),
            type: 'string',
            default: '',
            control: CONTROLS_ENUM.UploadButton,
        },
        backSrc: {
            label: i18n.t('Back image'),
            type: 'string',
            default: '',
            control: CONTROLS_ENUM.UploadButton,
        },
        frontText: {
            type: 'string',
            default: `<p class="ql-align-center"><span class="ql-font-Roboto" style="font-size: 16px; line-height: 1.5;">${i18n.t(
                'Front text',
            )}</span></p>`,
            minLength: 0,
            maxLength: 16000,
        },
        frontColor: {
            label: i18n.t('Front color'),
            type: 'string',
            default: '#eee',
            control: CONTROLS_ENUM.ColorPicker,
        },
        backText: {
            type: 'string',
            default: `<p class="ql-align-center"><span class="ql-font-Roboto" style="font-size: 16px; line-height: 1.5;">${i18n.t(
                'Back text',
            )}</span></p>`,
            minLength: 0,
            maxLength: 16000,
        },
        backColor: {
            label: i18n.t('Back color'),
            type: 'string',
            default: '#aaa',
            control: CONTROLS_ENUM.ColorPicker,
        },
    },
    [BLOCK.youtubeVideo]: {
        embedCode: {
            label: i18n.t('Embed code'),
            type: 'string',
            default: '',
            control: CONTROLS_ENUM.TextArea,
        },
    },
    [BLOCK.button]: {
        href: {
            label: i18n.t('Link'),
            type: 'string',
            default: 'https://interacty.me',
            control: CONTROLS_ENUM.InputWithModal,
            payload: {
                modalName: MODAL_NAMES.selectInternalPageModal,
            },
        },
        brad: {
            label: i18n.t('Border radius'),
            type: 'number',
            default: 4,
            min: 0,
            max: 99,
            control: CONTROLS_ENUM.TextInput,
        },
        bc: {
            label: i18n.t('Background color'),
            type: 'string',
            default: '#2990fb',
            control: CONTROLS_ENUM.ColorPicker,
        },
        text: {
            type: 'string',
            default:
                '<p class="ql-align-center"><span class="ql-font-Roboto" style="font-size: 20px; line-height: 1.5; color: rgb(255, 255, 255);">Click</span></p>',
            minLength: 0,
            maxLength: 16000,
        },
        pulse: {
            label: i18n.t('Pulse'),
            type: 'boolean',
            default: false,
            control: CONTROLS_ENUM.Checkbox,
        },
    },
    [BLOCK.interactiveImage]: {
        pins: {
            type: 'array',
            default: [],
        },
        count: {
            label: i18n.t('Number of tags'),
            type: 'number',
            default: 3,
            min: 0,
            max: 40,
            control: CONTROLS_ENUM.TextInput,
            payload: {
                controlType: 'number',
            },
        },
        bimg: {
            label: i18n.t('Image'),
            type: 'string',
            default: '',
            control: CONTROLS_ENUM.UploadButton,
        },
        pcl: {
            label: i18n.t('Tag color'),
            type: 'string',
            default: '#2990fb',
            control: CONTROLS_ENUM.ColorPicker,
        },
        psize: {
            label: i18n.t('Tag size'),
            type: 'number',
            default: 24,
            min: 4,
            max: 50,
            control: CONTROLS_ENUM.TextInput,
            payload: {
                controlType: 'number',
            },
        },
        pimg: {
            label: i18n.t('Tag image'),
            type: 'string',
            default: '',
            control: CONTROLS_ENUM.UploadButton,
        },
        btcolor: {
            label: i18n.t('Button text color'),
            type: 'string',
            default: '#fff',
            control: CONTROLS_ENUM.ColorPicker,
        },
    },
    [BLOCK.interactiveImage + '.pins']: PINS_SCHEMA_DICTIONARY,
    [BLOCK.hiddenObjects]: {
        pins: {
            type: 'array',
            default: [],
        },
        count: {
            label: i18n.t('Number of hidden tags'),
            type: 'number',
            default: 3,
            canBeEmpty: false,
            min: 1,
            max: 16,
            control: CONTROLS_ENUM.TextInput,
            payload: {
                controlType: 'number',
            },
        },
        bimg: {
            label: i18n.t('Image'),
            type: 'string',
            default: '',
            control: CONTROLS_ENUM.UploadButton,
        },
        pcl: {
            label: i18n.t('Tag/Button color'),
            type: 'string',
            default: '#2990fb',
            control: CONTROLS_ENUM.ColorPicker,
        },
        psize: {
            label: i18n.t('Hidden tag size'),
            type: 'number',
            default: 24,
            canBeEmpty: false,
            min: 4,
            max: 50,
            control: CONTROLS_ENUM.TextInput,
            payload: {
                controlType: 'number',
            },
        },
        pimg: {
            label: i18n.t('Tag image'),
            type: 'string',
            default: '',
            control: CONTROLS_ENUM.UploadButton,
        },
        btcolor: {
            label: i18n.t('Button text color'),
            type: 'string',
            default: '#fff',
            control: CONTROLS_ENUM.ColorPicker,
        },
        suct: {
            label: i18n.t('Header text in the final message'),
            type: 'string',
            default: '',
            control: CONTROLS_ENUM.TextInput,
        },
        sucd: {
            label: i18n.t('The main body of the final message'),
            type: 'string',
            default: '',
            control: CONTROLS_ENUM.TextArea,
        },
        sucImg: {
            label: i18n.t('Image of the final message'),
            type: 'string',
            default: '',
            control: CONTROLS_ENUM.UploadButton,
        },
        sucBlink: {
            label: i18n.t('Button link'),
            type: 'string',
            default: '',
            control: CONTROLS_ENUM.InputWithModal,
            payload: {
                modalName: MODAL_NAMES.selectInternalPageModal,
            },
        },
        sucBtext: {
            label: i18n.t('Button text'),
            type: 'string',
            default: 'Ok',
            control: CONTROLS_ENUM.TextInput,
        },
        isShowCover: {
            label: i18n.t('Show cover'),
            type: 'boolean',
            default: false,
            control: CONTROLS_ENUM.Checkbox,
        },
        coverHeader: {
            label: i18n.t('Header'),
            type: 'string',
            default: '',
            control: CONTROLS_ENUM.TextInput,
        },
        coverBtnText: {
            label: i18n.t('Button text'),
            type: 'string',
            default: 'Go',
            control: CONTROLS_ENUM.TextInput,
        },
        passwordList: {
            label: i18n.t('Privacy'),
            type: 'array',
            default: [],
            control: CONTROLS_ENUM.ArrayWithModal,
            payload: {
                modalName: MODAL_NAMES.privacySettingsModal,
                values: {
                    isEmpty: {
                        icon: iconUnlocked,
                        label: i18n.t('No restrictions'),
                    },
                    isFilled: {
                        icon: iconLocked,
                        label: i18n.t('Password access'),
                    },
                },
            },
        },
        isEnableRating: {
            label: i18n.t('Enable player ratings'),
            type: 'boolean',
            default: false,
            control: CONTROLS_ENUM.Checkbox,
        },
        numberOfAttempts: {
            label: i18n.t('Number of attempts'),
            type: 'number',
            default: '',
            canBeEmpty: true,
            min: 1,
            max: 1000000,
            control: CONTROLS_ENUM.TextInput,
            payload: {
                controlType: 'number',
            },
        },
        legalStatement: {
            label: i18n.t('Links to service policies (html)'),
            type: 'string',
            default: '',
            control: CONTROLS_ENUM.TextArea,
            maxLength: 600,
        },
        isShowRatingEmail: {
            label: i18n.t('Ask user email'),
            type: 'boolean',
            default: false,
            control: CONTROLS_ENUM.Checkbox,
        },
        enableTimer: {
            label: i18n.t('Enable timer'),
            type: 'boolean',
            default: false,
            control: CONTROLS_ENUM.Checkbox,
        },
    },
    [BLOCK.hiddenObjects + '.pins']: PINS_SCHEMA_DICTIONARY,
    [BLOCK.quiz]: {
        struct: {
            type: 'object',
            default: {},
        },
        colorTheme: {
            label: i18n.t('Color theme'),
            type: 'string',
            default: '#2990fb',
            control: CONTROLS_ENUM.ColorPicker,
        },
        progressBar: {
            label: i18n.t('Progress bar'),
            type: 'boolean',
            default: true,
            control: CONTROLS_ENUM.Checkbox,
        },
        showScores: {
            label: i18n.t('Show score on final screen'),
            type: 'boolean',
            default: true,
            control: CONTROLS_ENUM.Checkbox,
        },
        isShowLeadForm: {
            label: i18n.t('Show lead form'),
            type: 'boolean',
            default: false,
            control: CONTROLS_ENUM.Checkbox,
        },
        leadFormStruct: {
            label: i18n.t('Customize'),
            type: 'object',
            default: initLeadFormStructureByMode[leadFormMode.EMBEDDED],
            control: CONTROLS_ENUM.LinkWithModal,
            payload: {
                modalName: MODAL_NAMES.leadFormModal,
            },
        },
        callToActionEnabled: {
            label: i18n.t('Call to action button'),
            type: 'boolean',
            default: false,
            control: CONTROLS_ENUM.Checkbox,
        },
        callToActionText: {
            label: i18n.t('Button text'),
            type: 'string',
            default: '',
            control: CONTROLS_ENUM.TextInput,
        },
        callToActionLink: {
            label: i18n.t('Link'),
            type: 'string',
            default: '',
            control: CONTROLS_ENUM.InputWithModal,
            payload: {
                modalName: MODAL_NAMES.selectInternalPageModal,
            },
        },
    },
    [BLOCK.personalityQuiz]: {
        struct: {
            type: 'object',
            default: {},
        },
        colorTheme: {
            label: i18n.t('Color theme'),
            type: 'string',
            default: '#2990fb',
            control: CONTROLS_ENUM.ColorPicker,
        },
        progressBar: {
            label: i18n.t('Progress bar'),
            type: 'boolean',
            default: true,
            control: CONTROLS_ENUM.Checkbox,
        },
        callToActionEnabled: {
            label: i18n.t('Call to action button'),
            type: 'boolean',
            default: false,
            control: CONTROLS_ENUM.Checkbox,
        },
        callToActionText: {
            label: i18n.t('Button text'),
            type: 'string',
            default: '',
            control: CONTROLS_ENUM.TextInput,
        },
        callToActionLink: {
            label: i18n.t('Link'),
            type: 'string',
            default: '',
            control: CONTROLS_ENUM.InputWithModal,
            payload: {
                modalName: MODAL_NAMES.selectInternalPageModal,
            },
        },
    },
    [BLOCK.cookies]: {
        struct: {
            type: 'object',
            default: {},
        },
        colorTheme: {
            label: 'Color theme',
            type: 'string',
            default: '#AB9494',
            control: CONTROLS_ENUM.ColorPicker,
        },
        callToActionEnabled: {
            label: 'Call to action button',
            type: 'boolean',
            default: false,
            control: CONTROLS_ENUM.Checkbox,
        },
        callToActionText: {
            label: 'Button Text',
            type: 'string',
            default: '',
            control: CONTROLS_ENUM.TextInput,
        },
        callToActionLink: {
            label: 'Link',
            type: 'string',
            default: '',
            control: CONTROLS_ENUM.InputWithModal,
            payload: {
                modalName: MODAL_NAMES.selectInternalPageModal,
            },
        },
        backgroundImage: {
            label: 'Background image',
            type: 'string',
            default: '',
            control: CONTROLS_ENUM.UploadButton,
        },
    },
    [BLOCK.horoscope]: {
        struct: {
            type: 'object',
            default: {},
        },
        colorTheme: {
            label: 'Color theme',
            type: 'string',
            default: '#AB9494',
            control: CONTROLS_ENUM.ColorPicker,
        },
        callToActionEnabled: {
            label: 'Call to action button',
            type: 'boolean',
            default: false,
            control: CONTROLS_ENUM.Checkbox,
        },
        callToActionText: {
            label: 'Button Text',
            type: 'string',
            default: '',
            control: CONTROLS_ENUM.TextInput,
        },
        callToActionLink: {
            label: 'Link',
            type: 'string',
            default: '',
            control: CONTROLS_ENUM.InputWithModal,
            payload: {
                modalName: MODAL_NAMES.selectInternalPageModal,
            },
        },
        backgroundImage: {
            label: 'Background image',
            type: 'string',
            default: '',
            control: CONTROLS_ENUM.UploadButton,
        },
    },
    [BLOCK.thenNow]: {
        leftSrc: {
            label: i18n.t('Left image'),
            type: 'string',
            default: '',
            control: CONTROLS_ENUM.UploadButton,
        },
        rightSrc: {
            label: i18n.t('Right image'),
            type: 'string',
            default: '',
            control: CONTROLS_ENUM.UploadButton,
        },
        imageProportions: {
            label: i18n.t('Image proportions'),
            type: 'object',
            default: {
                value: '3|2',
                label: '3:2',
            },
            control: CONTROLS_ENUM.Select,
            payload: {
                items: [
                    {
                        value: '1|1',
                        label: '1:1',
                    },
                    {
                        value: '5|4',
                        label: '5:4',
                    },
                    {
                        value: '4|3',
                        label: '4:3',
                    },
                    {
                        value: '3|2',
                        label: '3:2',
                    },
                    {
                        value: '16|9',
                        label: '16:9',
                    },
                    {
                        value: '2|1',
                        label: '2:1',
                    },
                    {
                        value: '4|1',
                        label: '4:1',
                    },
                ],
            },
        },
    },
    [BLOCK.memoryCards]: {
        struct: {
            type: 'object',
            default: {},
        },
        colorTheme: {
            label: i18n.t('Color theme'),
            type: 'string',
            default: '#AB9494',
            control: CONTROLS_ENUM.ColorPicker,
        },
        passwordList: {
            label: i18n.t('Privacy'),
            type: 'array',
            default: [],
            control: CONTROLS_ENUM.ArrayWithModal,
            payload: {
                modalName: MODAL_NAMES.privacySettingsModal,
                values: {
                    isEmpty: {
                        icon: iconUnlocked,
                        label: i18n.t('No restrictions'),
                    },
                    isFilled: {
                        icon: iconLocked,
                        label: i18n.t('Password access'),
                    },
                },
            },
        },
        isEnableRating: {
            label: i18n.t('Enable player ratings'),
            type: 'boolean',
            default: false,
            control: CONTROLS_ENUM.Checkbox,
        },
        numberOfAttempts: {
            label: i18n.t('Number of attempts'),
            type: 'number',
            default: 30,
            canBeEmpty: true,
            min: 1,
            max: 1000000,
            control: CONTROLS_ENUM.TextInput,
            payload: {
                controlType: 'number',
            },
        },
        legalStatement: {
            label: i18n.t('Links to service policies (html)'),
            type: 'string',
            default: '',
            control: CONTROLS_ENUM.TextArea,
            maxLength: 600,
        },
        isShowRatingEmail: {
            label: i18n.t('Ask user email'),
            type: 'boolean',
            default: false,
            control: CONTROLS_ENUM.Checkbox,
        },
        enableTimer: {
            label: i18n.t('Time counter'),
            type: 'boolean',
            default: false,
            control: CONTROLS_ENUM.Checkbox,
        },
        enableStars: {
            label: i18n.t('Show stars on result page'),
            type: 'boolean',
            default: false,
            control: CONTROLS_ENUM.Checkbox,
        },
        starsTimeList: {
            label: i18n.t('Values in seconds'),
            type: 'string',
            default: '45, 30, 15',
            canBeUndefined: false,
            control: CONTROLS_ENUM.TextInput,
        },
        timerType: {
            type: 'object',
            default: {
                value: 'stopwatch',
                label: 'Classic timer',
            },
            control: CONTROLS_ENUM.RadioButton,
            payload: {
                flexDirection: 'row',
                items: [
                    {
                        value: 'stopwatch',
                        label: i18n.t('Classic timer'),
                    },
                    {
                        value: 'countdown',
                        label: i18n.t('Countdown'),
                    },
                ],
            },
        },
        countdownTime: {
            label: i18n.t('Value in seconds'),
            type: 'number',
            default: 30,
            canBeEmpty: false,
            min: 1,
            max: 1000000,
            control: CONTROLS_ENUM.TextInput,
            payload: {
                controlType: 'number',
            },
        },
        timeIsUpScreen: {
            label: i18n.t('Customize the “Time is up” page'),
            type: 'object',
            default: TIME_IS_UP_INIT_STATE,
            control: CONTROLS_ENUM.LinkWithModal,
            payload: {
                modalName: MODAL_NAMES.timeIsUpModal,
            },
        },
        isActionButton: {
            label: i18n.t('Call to action button'),
            type: 'boolean',
            default: false,
            control: CONTROLS_ENUM.Checkbox,
        },
        actionButtonText: {
            label: i18n.t('Button text'),
            type: 'string',
            default: '',
            control: CONTROLS_ENUM.TextInput,
        },
        actionButtonLink: {
            label: i18n.t('Link'),
            type: 'string',
            default: '',
            control: CONTROLS_ENUM.InputWithModal,
            payload: {
                modalName: MODAL_NAMES.selectInternalPageModal,
            },
        },
        integrationMetadata: {
            label: i18n.t('Metadata for SDK integration'),
            type: 'string',
            default: '',
            control: CONTROLS_ENUM.TextArea,
            maxLength: 600,
        },
        numberedCardBacks: {
            label: i18n.t('Number card backs'),
            type: 'boolean',
            default: false,
            control: CONTROLS_ENUM.Checkbox,
        },
        timeoutClosingCards: {
            label: i18n.t('Delay before flipping cards (in seconds)'),
            type: 'number',
            default: 1,
            canBeEmpty: false,
            min: 1,
            max: 10,
            control: CONTROLS_ENUM.TextInput,
            payload: {
                controlType: 'number',
            },
        },
    },
    [BLOCK.timeline]: {
        text: {
            type: 'string',
            default: `<p><span class="ql-font-Roboto" style="font-size: 16px; line-height: 1.5;">${i18n.t(
                'Start telling your story...',
            )}</span></p>`,
            minLength: 0,
            maxLength: 16000,
        },
        markTitle: {
            type: 'string',
            default: `${i18n.t('Date')}`,
            minLength: 0,
            maxLength: 100,
        },
        markSubtitle: {
            type: 'string',
            default: `${i18n.t('Section header')}`,
            minLength: 0,
            maxLength: 100,
        },
        imageUrl: {
            label: i18n.t('Choose Image'),
            type: 'string',
            default: '',
            control: CONTROLS_ENUM.UploadButton,
        },
        imageDescription: {
            label: i18n.t('Image caption'),
            type: 'string',
            default: '',
            minLength: 0,
            maxLength: 1000,
            control: CONTROLS_ENUM.TextInput,
        },
        // wrapperProps
        wP_bg: {
            label: i18n.t('Background color'),
            type: 'string',
            default: 'transparent',
            control: CONTROLS_ENUM.ColorPicker,
        },
    },
    [BLOCK.leadForm]: {
        struct: {
            type: 'object',
            default: initLeadFormStructureByMode[leadFormMode.INDEPENDENT],
        },
        colorTheme: {
            label: i18n.t('Color theme'),
            type: 'string',
            default: '#2990fb',
            control: CONTROLS_ENUM.ColorPicker,
        },
        isActionButton: {
            label: i18n.t('Call to action button'),
            type: 'boolean',
            default: false,
            control: CONTROLS_ENUM.Checkbox,
        },
        actionButtonText: {
            label: i18n.t('Button text'),
            type: 'string',
            default: '',
            control: CONTROLS_ENUM.TextInput,
        },
        actionButtonLink: {
            label: i18n.t('Link'),
            type: 'string',
            default: '',
            control: CONTROLS_ENUM.InputWithModal,
            payload: {
                modalName: MODAL_NAMES.selectInternalPageModal,
            },
        },
    },
    [BLOCK.findPair]: {
        struct: {
            type: 'object',
            default: {},
        },
        colorTheme: {
            label: i18n.t('Color theme'),
            type: 'string',
            default: '#AB9494',
            control: CONTROLS_ENUM.ColorPicker,
        },
        passwordList: {
            label: i18n.t('Privacy'),
            type: 'array',
            default: [],
            control: CONTROLS_ENUM.ArrayWithModal,
            payload: {
                modalName: MODAL_NAMES.privacySettingsModal,
                values: {
                    isEmpty: {
                        icon: iconUnlocked,
                        label: i18n.t('No restrictions'),
                    },
                    isFilled: {
                        icon: iconLocked,
                        label: i18n.t('Password access'),
                    },
                },
            },
        },
        isEnableRating: {
            label: i18n.t('Enable player ratings'),
            type: 'boolean',
            default: false,
            control: CONTROLS_ENUM.Checkbox,
        },
        numberOfAttempts: {
            label: i18n.t('Number of attempts'),
            type: 'number',
            default: 30,
            canBeEmpty: true,
            min: 1,
            max: 1000000,
            control: CONTROLS_ENUM.TextInput,
            payload: {
                controlType: 'number',
            },
        },
        legalStatement: {
            label: i18n.t('Links to service policies (html)'),
            type: 'string',
            default: '',
            control: CONTROLS_ENUM.TextArea,
            maxLength: 600,
        },
        isShowRatingEmail: {
            label: i18n.t('Ask user email'),
            type: 'boolean',
            default: false,
            control: CONTROLS_ENUM.Checkbox,
        },
        enableTimer: {
            label: i18n.t('Time counter'),
            type: 'boolean',
            default: false,
            control: CONTROLS_ENUM.Checkbox,
        },
        enableStars: {
            label: i18n.t('Show stars on result page'),
            type: 'boolean',
            default: false,
            control: CONTROLS_ENUM.Checkbox,
        },
        starsTimeList: {
            label: i18n.t('Values in seconds'),
            type: 'string',
            default: '',
            control: CONTROLS_ENUM.TextInput,
        },
        timerType: {
            type: 'object',
            default: {
                value: 'stopwatch',
                label: 'Classic timer',
            },
            control: CONTROLS_ENUM.RadioButton,
            payload: {
                flexDirection: 'row',
                items: [
                    {
                        value: 'stopwatch',
                        label: i18n.t('Classic timer'),
                    },
                    {
                        value: 'countdown',
                        label: i18n.t('Countdown'),
                    },
                ],
            },
        },
        countdownTime: {
            label: i18n.t('Value in seconds'),
            type: 'number',
            default: '',
            canBeEmpty: true,
            min: 1,
            max: 1000000,
            control: CONTROLS_ENUM.TextInput,
            payload: {
                controlType: 'number',
            },
        },
        timeIsUpScreen: {
            label: i18n.t('Customize the “Time is up” page'),
            type: 'object',
            default: TIME_IS_UP_INIT_STATE,
            control: CONTROLS_ENUM.LinkWithModal,
            payload: {
                modalName: MODAL_NAMES.timeIsUpModal,
            },
        },
        isActionButton: {
            label: i18n.t('Call to action button'),
            type: 'boolean',
            default: false,
            control: CONTROLS_ENUM.Checkbox,
        },
        actionButtonText: {
            label: i18n.t('Button text'),
            type: 'string',
            default: '',
            control: CONTROLS_ENUM.TextInput,
        },
        actionButtonLink: {
            label: i18n.t('Link'),
            type: 'string',
            default: '',
            control: CONTROLS_ENUM.InputWithModal,
            payload: {
                modalName: MODAL_NAMES.selectInternalPageModal,
            },
        },
        integrationMetadata: {
            label: i18n.t('Metadata for SDK integration'),
            type: 'string',
            default: '',
            control: CONTROLS_ENUM.TextArea,
            maxLength: 600,
        },
    },
    [BLOCK.slideshow]: {
        struct: {
            type: 'object',
            default: {
                slides: [
                    {
                        id: genUniqueId(),
                        image: DEFAULT_IMAGE_URL,
                        description: '',
                        hasTextOptions: false,
                        header: '',
                        imageCaption: '',
                    },
                ],
            },
        },
        colorTheme: {
            label: i18n.t('Color theme'),
            type: 'string',
            default: '#F9FAFD',
            control: CONTROLS_ENUM.ColorPicker,
        },
    },
    [BLOCK.puzzle]: {
        struct: {
            type: 'object',
            default: {},
        },
        colorTheme: {
            label: i18n.t('Color theme'),
            type: 'string',
            default: '#AB9494',
            control: CONTROLS_ENUM.ColorPicker,
        },
        passwordList: {
            label: i18n.t('Privacy'),
            type: 'array',
            default: [],
            control: CONTROLS_ENUM.ArrayWithModal,
            payload: {
                modalName: 'privacySettingsModal',
                values: {
                    isEmpty: {
                        icon: iconUnlocked,
                        label: i18n.t('No restrictions'),
                    },
                    isFilled: {
                        icon: iconLocked,
                        label: i18n.t('Password access'),
                    },
                },
            },
        },
        isEnableRating: {
            label: i18n.t('Enable player ratings'),
            type: 'boolean',
            default: false,
            control: CONTROLS_ENUM.Checkbox,
        },
        numberOfAttempts: {
            label: i18n.t('Number of attempts'),
            type: 'number',
            default: '',
            canBeEmpty: true,
            min: 1,
            max: 1000000,
            control: CONTROLS_ENUM.TextInput,
            payload: {
                controlType: 'number',
            },
        },
        legalStatement: {
            label: i18n.t('Links to service policies (html)'),
            type: 'string',
            default: '',
            control: CONTROLS_ENUM.TextArea,
            maxLength: 600,
        },
        isShowRatingEmail: {
            label: i18n.t('Ask user email'),
            type: 'boolean',
            default: false,
            control: CONTROLS_ENUM.Checkbox,
        },
        enableTimer: {
            label: i18n.t('Enable timer'),
            type: 'boolean',
            default: false,
            control: CONTROLS_ENUM.Checkbox,
        },
        enableStars: {
            label: i18n.t('Show stars on result page'),
            type: 'boolean',
            default: false,
            control: CONTROLS_ENUM.Checkbox,
        },
        starsTimeList: {
            label: i18n.t('Values in seconds'),
            type: 'string',
            default: '45, 30, 15',
            control: CONTROLS_ENUM.TextInput,
        },
        timerType: {
            type: 'object',
            default: {
                value: 'stopwatch',
                label: 'Classic timer',
            },
            control: CONTROLS_ENUM.RadioButton,
            payload: {
                flexDirection: 'row',
                items: [
                    {
                        value: 'stopwatch',
                        label: i18n.t('Classic timer'),
                    },
                    {
                        value: 'countdown',
                        label: i18n.t('Countdown'),
                    },
                ],
            },
        },
        countdownTime: {
            label: i18n.t('Value in seconds'),
            type: 'number',
            default: 30,
            canBeEmpty: true,
            min: 1,
            max: 1000000,
            control: CONTROLS_ENUM.TextInput,
            payload: {
                controlType: 'number',
            },
        },
        timeIsUpScreen: {
            label: i18n.t('Customize the “Time is up” page'),
            type: 'object',
            default: TIME_IS_UP_INIT_STATE,
            control: CONTROLS_ENUM.LinkWithModal,
            payload: {
                modalName: MODAL_NAMES.timeIsUpModal,
            },
        },
        isActionButton: {
            label: i18n.t('Call to action button'),
            type: 'boolean',
            default: false,
            control: CONTROLS_ENUM.Checkbox,
        },
        actionButtonText: {
            label: i18n.t('Button text'),
            type: 'string',
            default: '',
            control: CONTROLS_ENUM.TextInput,
        },
        actionButtonLink: {
            label: i18n.t('Link'),
            type: 'string',
            default: '',
            control: CONTROLS_ENUM.InputWithModal,
            payload: {
                modalName: MODAL_NAMES.selectInternalPageModal,
            },
        },
    },
}

export { STATIC_BLOCKS, INTERACTIVE_BLOCKS, BLOCK_DICTIONARY, BLOCK_SCHEMA_DICTIONARY }
